import { Component, Input, inject } from '@angular/core';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { DatePipe } from '@angular/common';
import { PayloadDetailsComponent } from './payload-details/payload-details.component';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { ProcessService } from '../../services/process.service';

@Component({
  selector: 'hub-timeline-card',
  standalone: true,
  imports: [CardModule, ButtonModule, DatePipe, PayloadDetailsComponent, DynamicDialogModule],
  template: `
    <p-card [header]="step" subheader="{{ createdDate | date: 'dd/MM/yyyy' }}" [style]="{ width: '360px' }">
      <div>
        <p><span class="font-bold">Status:</span> {{ status }}</p>
      </div>
      <ng-template pTemplate="footer">
        <p-button label="Detalhes" size="small" icon="pi pi-plus" [text]="true" (click)="openStepDetails()" />
      </ng-template>
    </p-card>
  `,
  styleUrl: './timeline-card.component.scss',
  providers: [DialogService],
})
export class TimelineCardComponent {
  public showStepDetails: boolean = false;
  private dialogService = inject(DialogService);
  private processService = inject(ProcessService);

  @Input({ required: true }) status: string = '';
  @Input({ required: true }) step: string = '';
  @Input({ required: true }) createdDate: string = '';
  @Input({ required: true }) processStepId!: string;

  public inputPayload: any;
  public outputPayload: any;

  public async openStepDetails(): Promise<void> {
    this.processService.getProcessStepById(this.processStepId).subscribe({
      next: response => {
        this.inputPayload = response.details.inputPayloads;
        this.outputPayload = response.details.outputPayloads;
      },

      complete: () => {
        this.dialogService.open(PayloadDetailsComponent, {
          data: {
            input: this.inputPayload,
            output: this.outputPayload,
          },
          header: `Payload - ${this.step}`,
          width: '40%',
        });
      },
    });
  }

  private async getStepDetails() {}
}
